import { motion } from "framer-motion";
import { TreePine, Mountain, Landmark, Utensils } from "lucide-react";
import { FEATURES, STATS } from "../data/content";

const ICONS = { TreePine, Mountain, Landmark, Utensils };

const fadeUp = {
  hidden: { opacity: 0, y: 28 },
  show: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, delay: i * 0.1 },
  }),
};

export const Features = () => {
  return (
    <section
      data-testid="features-section"
      className="bg-[#243E2C] text-[#EFECE4]"
    >
      {/* Stats strip */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-2 md:grid-cols-4 border-b border-white/10">
        {STATS.map((s, i) => (
          <motion.div
            key={s.label}
            variants={fadeUp}
            custom={i}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
            className="py-10 md:py-14 text-center border-r last:border-r-0 border-white/10 even:border-r-0 md:even:border-r"
          >
            <div className="font-serif text-3xl md:text-5xl text-[#C4A575]">
              {s.value}
            </div>
            <div className="text-xs uppercase tracking-[0.18em] text-[#EFECE4]/60 mt-2">
              {s.label}
            </div>
          </motion.div>
        ))}
      </div>

      {/* Feature grid */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28">
        <p className="uppercase text-xs tracking-[0.25em] text-[#C4A575] font-semibold text-center">
          Why Nine Furlongs
        </p>
        <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-center mt-4 max-w-2xl mx-auto leading-tight">
          An estate that exists to slow you down
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px mt-16 bg-white/10 border border-white/10">
          {FEATURES.map((f, i) => {
            const Icon = ICONS[f.icon];
            return (
              <motion.div
                key={f.title}
                variants={fadeUp}
                custom={i}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true }}
                className="bg-[#243E2C] p-8 md:p-10 group hover:bg-[#1A2E20] transition-colors duration-500"
                data-testid={`feature-card-${i}`}
              >
                <Icon
                  size={32}
                  strokeWidth={1.2}
                  className="text-[#C4A575] group-hover:scale-110 transition-transform duration-500"
                />
                <h3 className="font-serif text-2xl mt-6">{f.title}</h3>
                <p className="text-sm text-[#EFECE4]/70 mt-3 leading-relaxed">
                  {f.desc}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
